import React, { useState, useEffect } from "react";
import styles from "./HomeMobile.module.css";
import axios from "axios";
import { NavLink } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import girl from "../../assets/images/girl.png";

import searchicon from "../../assets/icons/searchicon.png";
import addcart from "../../assets/icons/addcart.png";
import FooterMobile from "../FooterMobile/FooterMobile";

const Home = () => {
  const MAIN_URL = process.env.REACT_APP_URL
  const token = localStorage.getItem("token");

  // for geting the all products data
  
  const [viewproducts, setViewproducts] = useState([]);
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(
          `${MAIN_URL}/api/product/getAllProducts`
        );
        setViewproducts(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  // APPLY FILTER LOGIC--------------------------
  const [filters, setFilters] = useState({
    color: "",
    productType: "",
    brand: "",
    price: "",
  });

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(
          `${MAIN_URL}/api/product/getAllProducts`,
          {
            params: filters,
          }
        );
        setViewproducts(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, [filters]);

  const handleFilterChange = (event) => {
    const { name, value } = event.target;

    if (value === "featured") {
      setFilters({ ...filters, [name]: "" });
    } else {
      setFilters({ ...filters, [name]: value });
    }
  };

  // SORTING PRODUCT
  const handleSortChange = async (event) => {
    const selectedSortOption = event.target.value;
    try {
      const response = await axios.get(
        `${MAIN_URL}/api/product/getAllProducts`,
        {
          params: { sort: selectedSortOption }, 
        }
      );
      setViewproducts(response.data);
    } catch (error) {
      console.error("Error fetching sorted products:", error);
    }
  };
  // SEARCH BAR

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };
  useEffect(() => {
    const searchProducts = async () => {
      try {
        const response = await axios.get(
          `${MAIN_URL}/api/product/searchProducts`,
          {
            params: { search: searchQuery },
          }
        );
        setViewproducts(response.data);
      } catch (error) {
        console.error("Error searching products:", error);
      }
    };

    searchProducts();
  }, [searchQuery]);

  // ADD TO CART LOGIC

  const addToCart = async (product) => {
    try {
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      await axios.post(
        `${MAIN_URL}/api/cart/addToCart/${product._id}`,
        null,
        config
      );
      toast.success(`${product.productName} added to cart!`);
    } catch (error) {
      console.error("Error adding product to cart:", error);
      toast.error("Failed to add product to cart");
    }
  };

  return (
    <>
      <div className={styles.home}>
      <div className={styles.home_mainContainer}>

        <div className={styles.bar_heading}>
            <div className={styles.search_bar}>
              <img className={styles.search_img} src={searchicon} alt="" />
              <input
                type="text"
                className={styles.search_input}
                placeholder="Search Musicart"
                onChange={handleSearch}
              />
            </div>
        </div>
        {/* BANNER ///////////////////////////////// */}
        <div className={styles.banner_bar}>
        <div className={styles.linergradient}>
              <div className={styles.left_linergradient}>
              <span>
                Grab upto 50% off on 
                Selected headphones
              </span>
              <button> <NavLink className={styles.link_btn} to="/viewcart">Buy Now</NavLink></button>
              </div>
              <img src={girl} className={styles.girl} alt="girl" />
            </div>
        </div>
        {/* FILTER BAR SECTION ////////////////////////////// */}
        <div className={styles.filter_container}>
          <div className={styles.filter_bar}>
            {/* Sort Options */}
            <div className={styles.filter_sorting_section}>
              <select id="sorting" onChange={handleSortChange}>
                <option value="" disabled selected hidden>
                  Sort by:
                </option>
                <option value="Featured">Featured</option>
                <option value="lowest">Price: Lowest</option>
                <option value="highest">Price: Highest</option>
                <option value="a-z">Name: (A-Z)</option>
                <option value="z-a">Name: (Z-A)</option>
              </select>
            </div>
            {/* Filter by Headphone Type */}

            <div className={styles.filter_section_headphone}>
              <select
                name="productType"
                id="productType"
                onChange={handleFilterChange}
              >
                <option value="" disabled selected hidden>
                  Headphone type
                </option>
                <option value="featured">Featured</option>
                <option value="in-ear headphone">In-ear headphone</option>
                <option value="on-ear headphone">On-ear headphone</option>
                <option value="over-ear headphone">Over-ear headphone</option>
              </select>
            </div>

            {/* Filter by Company/Brand */}
            <div className={styles.filter_section_company}>
              <select name="brand" id="brand" onChange={handleFilterChange}>
                <option value="" disabled selected hidden>
                  Company
                </option>
                <option value="featured">Featured</option>

                <option value="jbl">JBL</option>
                <option value="sony">Sony</option>
                <option value="boat">Boat</option>
                <option value="Zebronics">Zebronics</option>
                <option value="Marshall">Marshall</option>
                <option value="Ptron">Ptron</option>
              </select>
            </div>

            {/* Filter by Color */}
            <div className={styles.filter_section_color}>
              <select name="color" id="color" onChange={handleFilterChange}>
                <option value="" disabled selected hidden>
                  Colour
                </option>
                <option value="featured">Featured</option>

                <option value="blue">Blue</option>
                <option value="black">Black</option>
                <option value="white">White</option>
                <option value="brown">Brown</option>
              </select>
            </div>

            {/* Filter by Price */}
            <div className={styles.filter_section_price}>
              <select name="price" id="price" onChange={handleFilterChange}>
                <option value="" disabled selected hidden>
                  Price
                </option>
                <option value="featured">Featured</option>
                <option value="0-1000">₹0 - ₹1,000</option>
                <option value="1000-10000">₹1,000 - ₹10,000</option>
                <option value="10000-20000">₹10,000 - ₹20,000</option>
              </select>
            </div>
          </div>
        </div>
        {/* FILTER BAR SECTION ---------------------------- */}
        <div className={styles.home_container}>
          {/* PRODUCT DISPLAY SECTION */}
          <div className={styles.all_products}>
            {viewproducts.map((product) => (
              <div key={product._id} className={styles.productlist}>
                <div className={styles.product_img_section}>
                  <div className={styles.product_img}>
                    <NavLink
                      to={`/singleproduct/${product._id}`}
                      key={product._id}
                    >
                      <img
                        src={product.imgUrl}
                        alt={viewproducts.productName}
                      />
                    </NavLink>
                  </div>
                  {token && (
                  <div
                    className={styles.addcart}
                    onClick={() => addToCart(product)}
                  >
                    <img src={addcart} alt="addcart" />
                  </div>
                  )}
                </div>
                <div className={styles.product_details}>
                  <p className={styles.product_name}>{product.productName}</p>
                  <p className={styles.product_price}>
                    Price - ₹ {product.price}
                  </p>
                  <p className={styles.product_color}>
                    {product.color} | <span> {product.productType}</span>
                  </p>
                </div>
              </div>
            ))}
          </div>
          {/* PRODUCT DISPLAY SECTION */}
        </div>
        </div>

       <FooterMobile/>
      </div>
      <ToastContainer />
    </>
  );
};

export default Home;
